/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Protocol_Delivery_ModeInputs */

const cs_tasks_protocol_delivery_mode = /** @type {(inputs: Tasks_Protocol_Delivery_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doručení`)
};

const en_tasks_protocol_delivery_mode = /** @type {(inputs: Tasks_Protocol_Delivery_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivery`)
};

/**
* | output |
* | --- |
* | "Delivery" |
*
* @param {Tasks_Protocol_Delivery_ModeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_protocol_delivery_mode = /** @type {((inputs?: Tasks_Protocol_Delivery_ModeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Protocol_Delivery_ModeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_protocol_delivery_mode(inputs)
	return cs_tasks_protocol_delivery_mode(inputs)
});